<template>
<!--  安全中心-->
  <div class="security">
    <div class="type-title">
      <div class="icon"></div>
      <h3 class="type-text">登录方式</h3>
    </div>
    <a-row class="list-box" type="flex">
      <a-col class="list-item" v-for="(item, index) of loginType.list" :key="index">
        <p class="title">
          <span class="title-text">{{item.title}}</span>
          <img class="icon" :src="item.icon" alt="" v-if="item.icon">
        </p>

        <template v-if="item.key !== 'isBindVOS'">
          <p class="value">{{item.valuePrefix}}{{item.value}}</p>
          <p @click="changeState(item)" class=re-bind>
            {{ item.handler }}<img class="icon" src="../../../assets/images/web/rightarrow.png" alt="">
          </p>
        </template>

        <template v-else>
          <p class="value"></p>
          <p @click="changeState(item)" class=re-bind>
            <template v-for="(ele, i) of item.value" :key="i">
              <img v-if="ele.icon" :src="ele.icon"/>
            </template>
          </p>
        </template>
      </a-col>
    </a-row>

    <div class="type-title first-title">
      <div class="icon"></div>
      <h3 class="type-text">账号安全</h3>
    </div>
    <a-row class="list-box" type="flex">
      <a-col class="list-item list-horizontal">
        <div class="icon-box">
          <img class="icon" :src="Icons.Equipment" alt="">
        </div>
        <section class="content-top">
          <div class="security-title">
            <span class="text">登录设备管理</span>
            <p class="action" @click="toLoginDevice">
              <span class="text">查看更多</span>
              <img :src="Icons.rightArrowGary" alt="">
            </p>
          </div>
          <span class="desc">上次登录：{{accountSecurityData.deviceName}}</span>
        </section>
      </a-col>

      <li class="list-item list-horizontal">
        <div class="icon-box">
          <img class="icon" :src="Icons.Security" alt="">
        </div>
        <section class="content-top">
          <div class="security-title">
            <span class="text">密保问题</span>
            <p class="action">
              <span class="text">去设置</span>
              <img :src="Icons.rightArrowGary" alt="">
            </p>
          </div>

          <span class="desc">设置密码安全问题</span>
        </section>
      </li>
    </a-row>

    <!--统一安全验证的弹窗-->
    <safeVerify ref="safeCheck" @handleOperate="handleOperate"/>

    <!--重绑手机的弹窗-->
    <a-modal
      class="bind-phone-modal"
      :visible="mobileVisible"
      @cancel="closeMobileModal"
      :destroyOnClose="true"
      :centered="true"
      :footer="null"
    >
      <h3 class="title">绑定新手机</h3>
      <!-- 第一步-->
      <template v-if="bindPhoneStep === 1">
        <p class="tip">输入新手机号，点击下一步，将会发送一条验证短信到手机</p>
        <a-input v-model:value="phone" placeholder="请输入新手机号">
          <template #prefix>
            <img src="../../../assets/images/Phone.svg" alt="">
          </template>
        </a-input>

        <a-button
          @click="getCode(2, 'bindPhoneStep')"
          :disabled="phone === ''"
          type="primary"
          block>发送验证码</a-button>
      </template>

      <!-- 第二步-->
      <template v-if="bindPhoneStep === 2">
        <p class="tip">已向{{phone}} 发送了一条验证短信</p>
        <div class="check-code">
          <span class="text">请输入6位数字验证码</span>
          <span v-if="second" class="text">{{second + 'S'}}</span>
          <span v-else class="text" @click="getCode(2, 'bindPhoneStep')">重新发送</span>
        </div>
        <div class="btn-group">
          <template v-for="(item, index) of phoneCode.list" :key="index">
            <a-input
              class="phone-code-input"
              @change="val => phoneCodeChange(val, item, index)"
              v-model:value="item.value"
              type="text" inputmode="numeric" autocomplete="one-time-code"
            ></a-input>
          </template>
        </div>

        <a-button
          @click="bindingMobile"
          :disabled="phoneCode.list.some(item => item.value === '')"
          type="primary"
          block>完成绑定</a-button>
      </template>
    </a-modal>

    <!--密码操作的弹窗-->
    <a-modal
      class="bind-phone-modal"
      :visible="pwdVisible"
      @cancel="closePwdModal"
      :destroyOnClose="true"
      :centered="true"
      :footer="null"
    >
      <h3 class="title">修改密码</h3>
      <p class="tip">密码长度 6~32 数字或字母组合，区分大小写</p>

      <a-form
        ref="pwdLogin"
        class="login-form"
        :model="pwdState"
        :rules="pwdRules"
        @finish="changePwd"
      >
        <a-form-item name="newPassword">
          <a-input-password v-model:value="pwdState.newPassword" type="password" autocomplete placeholder="设置密码">
            <template #prefix>
              <img src="../../../assets/images/password.svg" alt="">
            </template>
          </a-input-password>
        </a-form-item>

        <a-form-item name="confirmPassword">
          <a-input-password v-model:value="pwdState.confirmPassword" type="password" autocomplete placeholder="确认密码">
            <template #prefix>
              <img src="../../../assets/images/password.svg" alt="">
            </template>
          </a-input-password>
        </a-form-item>

        <!-- @click="showVerify"-->
        <a-button
          block
          type="primary"
          html-type="submit"
          :disabled="pwdState.confirmPassword === ''||pwdState.newPassword === ''"
          :loading="btnLoading.loading"
        >确认修改</a-button>
      </a-form>

    </a-modal>
  </div>
</template>

<script setup>
import { reactive, ref, onBeforeMount, computed, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import Icons from '@/assets/images/web';
import safeVerify from '@/components/safeVerify';
import { GET } from '@/packge/http';
import { message } from 'ant-design-vue';
import { prePhoneCode, countDown, second, phoneCode, phoneCodeChange } from '@/utils/setup/captchaInput';
import { submitChangePwd, pwdState, samePassword } from '@/utils/setup/handlePwd';
import { bindPhoneStep, phone, mobileVisible, getCode, reBindPhone, userMobile } from '@/utils/setup/bindMobile';
import { pwdValidate } from '@/utils/setup/pwdValidate';
import { logOut } from '@/utils/setup/logOut';
import { getUserInfo } from '@/utils/setup/userInfo';

const safeCheck = ref('safeCheck');

/** 关闭弹窗（修改密码） */
function closePwdModal () {
  pwdState.newPassword = '';
  pwdState.confirmPassword = '';
  pwdVisible.value = false;
}

/** 关闭弹窗（重绑手机） */
function closeMobileModal () {
  phone.value = '';
  phoneCode.list.forEach(item => { item.value = ''; });
  mobileVisible.value = false;
}

async function bindingMobile () {
  await reBindPhone();
  getBingInfo();
  getUserInfo();
}

const router = useRouter();
function changeState (item) {
  if (item.key !== 'isBindVOS') {
    if (item.key === 'email') { return; }
    safeCheck.value.operateState(item);
  } else {
    router.push({ name: 'thirdAccount' });
  }
}

let btnLoading = { loading: false };
let pwdVisible = ref(false);
let typeObj = reactive({
  phonenumber: changePhone,
  email: operateEmail,
  editPwdTime: operatePassword,
  isBindVOS: thirdAccount
});

let pwdRules = reactive({
  newPassword: [
    { validator: pwdValidate }

  ],
  confirmPassword: [
    { validator: pwdValidate },
    { validator: samePassword }
  ]
});

const iconObj = {
  wechat: [Icons.wechatActive, Icons.wechatGrey],
  weibo: [Icons.weiboActive, Icons.weibotGrey],
  huawei: [Icons.huawei, null] // 已绑定显示图标，未绑定不显示
};
let accountSecurityData = reactive({ deviceName: '' });
let loginType = reactive({
  list: [
    {
      key: 'phonenumber',
      title: '绑定手机',
      icon: Icons.complete,
      valuePrefix: '已绑定：',
      value: '',
      handler: '重新绑定'
    },
    {
      key: 'editPwdTime',
      title: '登录密码',
      icon: Icons.complete,
      valuePrefix: '上次修改：',
      value: '',
      handler: '修改密码'
    },
    {
      key: 'email',
      title: '绑定邮箱',
      icon: Icons.warning,
      valuePrefix: '',
      value: '',
      handler: '立即绑定'
    },
    {
      key: 'isBindVOS',
      title: '第三方账号',
      // icon: Icons.warning,
      value: [
        { id: 'wechat', title: '微信', status: false, icon: Icons.wechatGrey },
        { id: 'huawei', title: '华为', status: false, icon: Icons.huawei }
        // { id: 'weibo', title: '微博', status: false, icon: Icons.weibotGrey }
      ]
    }
  ]
});

/** 获取用户绑定信息 */
function getBingInfo () {
  GET({
    url: '/account/bingInfo',
    params: {}
  }).then(({ data }) => {
    accountSecurityData.deviceName = data.deviceName;
    loginType.list.forEach(item => {
      if (item.key === 'isBindVOS') {
        item.value.forEach(item => {
          data.isBindVOS.forEach((ele) => {
            if (item.title === ele.title) {
              item.status = ele.status;
              const icon = iconObj[item.id];
              item.icon = ele.status ? icon[0] : icon[1];
            }
          });
        });
      } else {
        item.value = data[item.key];
      }

      if (['phonenumber', 'email'].some(el => el === item.key)) {
        item.valuePrefix = item.value ? '已绑定：' : '未绑定：';
      }
    });
  });
}
onBeforeMount(() => {
  console.log('navigation: ', window.navigator);
  getBingInfo();
});

function toLoginDevice () {
  router.push({ name: 'loginDevice' });
}

function handleOperate (item) {
  typeObj[item.key]();
}

/** 修改手机 */
function changePhone () {
  mobileVisible.value = true;
}

/** 操作邮箱 */
function operateEmail () {}
/** 操作密码 需安全验证 */
function operatePassword () {
  pwdVisible.value = true;
}
/** 修改密码 */
async function changePwd () {
  await submitChangePwd();
  message.success('修改成功');
  pwdVisible.value = false;
  logOut();
}
/** 修改第三方账号 */
function thirdAccount () {
  router.push({ name: 'thirdAccount' });
}
</script>

<style lang="scss" scoped>
.security {
  .first-title {
    margin-top: 80px;
  }
  .list-horizontal {
    display: flex;
    .icon-box {
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: rgba(244, 247, 251, 1);
    }
    .content-top {
      width: calc(100% - 72px);
    }
    .security-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-width: 147px;
      .text {
        color: rgba(43, 54, 74, 1);
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 14px;
        line-height: 14px;
        cursor: pointer;
      }
    }
    .action {
      .text {
        color: rgba(134, 143, 156, 1);
        font-family: PingFang SC;
        font-size: 12px;
        line-height: 12px;
      }
    }
    .desc {
      margin-top: 8px;
      color: rgba(134, 143, 156, 1);
      font-size: 12px;
      line-height: 16px;
    }
  }

}
</style>

<style lang="scss">
.bind-phone-modal {
  width: 480px !important;
  .title {
    margin-top: 32px;
    color: rgba(0, 19, 46, 1);
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
  }
  .tip {
    margin-top: 12px;
    color: rgba(134, 143, 156, 1);
    font-size: 14px;
    line-height: 18px;
  }

  .login-form {
    margin-top: 32px;
  }
  .ant-btn {
    margin-top: 16px;
    height: 56px;
    width: 416px;
  }

  .ant-input-affix-wrapper {
    margin-top: 32px;
    height: 48px;
  }
}
</style>
